//import React, { useEffect, useState } from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL }  from "../config";
import axios from "axios";
 import {
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaInstagram,
} from "react-icons/fa";
//import InputField from "./InputField"; // adjust path if needed

// ================= STYLES =================

const container = {
  padding: "20px",
  maxWidth: "1000px",
  margin: "0 auto",
};

const heading = {
  textAlign: "center",
  marginBottom: "30px",
  fontSize: "28px",
  color: "#1e90ff",
};

const loadingStyle = {
  textAlign: "center",
  marginTop: "50px",
  fontSize: "18px",
};

const errorStyle = {
  color: "red",
  textAlign: "center",
  marginTop: "50px",
  fontSize: "18px",
};

const searchContainer = {
  display: "flex",
  justifyContent: "center",
  gap: "15px",
  marginBottom: "30px",
  flexWrap: "wrap",
};

const searchInput = {
  padding: "10px 15px",
  borderRadius: "6px",
  border: "1px solid #908c8cff",
  minWidth: "200px",
};

const jobList = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
};

const jobCard = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  padding: "20px",
  background: "#f0f4f8",
  borderRadius: "12px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
  position: "relative",
};

const jobTitle = {
  margin: "0 0 5px 0",
  color: "#FF6F61",
  fontWeight: "600",
};

const jobInfo = {
  margin: "0 0 5px 0",
  color: "#555",
};

const jobSkills = {
  margin: "0 0 5px 0",
  color: "#444",
};

// const jobId = {
//   margin: 0,
//   fontStyle: "italic",
//   color: "#777",
// };

const buttonGroup = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginLeft: "20px",
};

const shareBtn = {
  padding: "8px 15px",
  border: "none",
  borderRadius: "5px",
  background: "#FFB400",
  cursor: "pointer",
  color: "#fff",
  fontWeight: "600",
};

const applyBtn = {
  padding: "8px 15px",
  border: "none",
  borderRadius: "5px",
  background: "#1E90FF",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "600",
};

// ===== Modal & Form Styles =====

const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalContent = {
  backgroundColor: "#fff",
  borderRadius: "10px",
  padding: "30px",
  width: "90%",
  maxWidth: "700px",
  maxHeight: "90vh",
  overflowY: "auto",
};

const formGroup = {
  marginBottom: "15px",
  display: "flex",
  flexDirection: "column",
};

const labelStyle = {
  marginBottom: "6px",
  fontWeight: "600",
  color: "#333",
};

const inputStyle = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "16px",
};

const errorText = {
  color: "red",
  fontSize: "13px",
  marginTop: "4px",
};

const btnGroupModal = {
  marginTop: "20px",
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
};

const btnSubmit = {
  padding: "10px 20px",
  backgroundColor: "#1E90FF",
  border: "none",
  borderRadius: "6px",
  color: "white",
  fontWeight: "600",
  cursor: "pointer",
};

// const btnCancel = {
//   padding: "10px 20px",
//   backgroundColor: "#ccc",
//   border: "none",
//   borderRadius: "6px",
//   color: "#333",
//   fontWeight: "600",
//   cursor: "pointer",
// };

// ================= COMPONENT =================

export default function Jobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dropdownVisibleId, setDropdownVisibleId] = useState(null);
  const [applyJob, setApplyJob] = useState(null); // which job is being applied (modal open)
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    experience: "",
    skill: "",
    location: "",
  });

  useEffect(() => {
    axios
      .get(`${API_URL}/Career/GetopenJob`)
      .then((res) => {
        setJobs(res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
        setError("Unable to fetch jobs");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filteredJobs = jobs.filter((job) => {
  const titleMatch =
    !filters.jobTitle ||
    (job.title &&
      job.title.toLowerCase() === filters.jobTitle.toLowerCase());

  // const expMatch =
  //   !filters.experience ||
  //   (job.experience &&
  //     job.experience.toLowerCase() === filters.experience.toLowerCase());

  const skillMatch =
    !filters.skill ||
    (job.skills &&
      job.skills.toLowerCase().includes(filters.skill.toLowerCase()));

  const locMatch =
    !filters.location ||
    (job.workLocation &&
      job.workLocation.toLowerCase().includes(filters.location.toLowerCase()));

  return titleMatch &&  skillMatch && locMatch;
});


  // ===== Application Form State =====

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    location: "",
    skill: "",
    experience: "",
    ctc: "",
    expected: "",
    notice: "",
    resume: null,
  });

  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData((prev) => ({
        ...prev,
        resume: files[0] || null,
      }));
      setUploadedFileName("");
      setErrors((prev) => ({ ...prev, resume: null }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
  const newErrors = {};
  if (!formData.firstName || !String(formData.firstName).trim()) newErrors.firstName = "First Name is required";
  if (!formData.lastName || !String(formData.lastName).trim()) newErrors.lastName = "Last Name is required";
  if (!formData.email || !String(formData.email).trim()) newErrors.email = "Email is required";
  else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email";
  if (!formData.phone || !String(formData.phone).trim()) newErrors.phone = "Phone is required";
  else if (!/^\d{10}$/.test(formData.phone)) newErrors.phone = "Phone must be 10 digits";
  if (!formData.location || !String(formData.location).trim()) newErrors.location = "Location is required";
  if (!formData.skill || !String(formData.skill).trim()) newErrors.skill = "Skill is required";
  if (!formData.experience || !String(formData.experience).trim()) newErrors.experience = "Experience is required";
  if (!formData.ctc || !String(formData.ctc).trim()) newErrors.ctc = "CTC is required";
  if (!formData.expected || !String(formData.expected).trim()) newErrors.expected = "Expected CTC is required";
  if (!formData.notice || !String(formData.notice).trim()) newErrors.notice = "Notice Period is required";
  if (!formData.resume) newErrors.resume = "Please upload your CV (PDF only)";
  else if (formData.resume.type !== "application/pdf") newErrors.resume = "Only PDF files allowed";
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const handleUpload = async () => {
    if (!formData.resume) {
      setErrors((prev) => ({ ...prev, resume: "Please select a file first" }));
      return;
    }
    if (formData.resume.type !== "application/pdf") {
      setErrors((prev) => ({ ...prev, resume: "Only PDF files are allowed" }));
      return;
    }

    setUploading(true);
    try {
      const data = new FormData();
      data.append("file", formData.resume, formData.resume.name);

      // Use your real upload API endpoint
      const response = await fetch(`${API_URL}/Career/UploadCV`, {
        method: "POST",
        body: data,
      });

      if (!response.ok) throw new Error("Failed to upload CV");

      const result = await response.json();

      setFormData((prev) => ({
        ...prev,
        firstName: result.firstName || prev.firstName,
        lastName: result.lastName || prev.lastName,
        email: result.email || prev.email,
        phone: result.mobileNo || prev.phone,
        location: result.city || prev.location,
        skill: result.skills || prev.skill,
        experience: result.relevantExp || prev.experience,
        ctc: result.ctc || prev.ctc,
        expected: result.expected || prev.expected,
        notice: result.notice || prev.notice,
      }));

      setUploadedFileName(formData.resume.name);
    } catch (err) {
      alert("Upload error: " + err.message);
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    if (!uploadedFileName) {
      alert("Please upload your CV before submitting!");
      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        Name: formData.firstName + " " + formData.lastName,
        FirstName: formData.firstName,
        LastName: formData.lastName,
        Email1: formData.email,
        MobileNo: formData.phone,
        City: formData.location,
        KeySkills: formData.skill,
        TotalExp: formData.experience,
        CurrentCTC: formData.ctc,
        ExpectedCTC: formData.expected,
        NoticePeriod: formData.notice,
        JobOrderID: applyJob?.joborderId || 0,
      };

      await axios.post(
        `${API_URL}/Career/EmailCareerDetails`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Application submitted successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        location: "",
        skill: "",
        experience: "",
        ctc: "",
        expected: "",
        notice: "",
        resume: null,
      });
      setUploadedFileName("");
      setErrors({});
      setApplyJob(null);
    } catch (err) {
      alert("Error submitting application. Please try again later.");
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const closeModal = () => {
    setApplyJob(null);
    setErrors({});
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      location: "",
      skill: "",
      experience: "",
      ctc: "",
      expected: "",
      notice: "",
      resume: null,
    });
    setUploadedFileName("");
  };

  if (loading) return <p style={loadingStyle}>Loading jobs...</p>;
  if (error) return <p style={errorStyle}>{error}</p>;

  return (
    <div style={container}>
      <h2 style={heading}>Available Job Openings</h2>

      <div style={searchContainer}>
        {/* <input
          type="text"
          name="jobTitle"
          placeholder="Title of job you are looking for"
          value={filters.jobTitle}
          onChange={handleFilterChange}
          style={searchInput}
        /> */}
        <input
          type="text"
          name="skill"
          placeholder="Skill / Role"
          value={filters.skill}
          onChange={handleFilterChange}
          style={searchInput}
        />
        <input
          type="text"
          name="location"
          placeholder="Preferred Location"
          value={filters.workLocation}
          onChange={handleFilterChange}
          style={searchInput}
        />
      </div>

      <div style={jobList}>
        {filteredJobs.length > 0 ? (
          filteredJobs.map((job) => (
            <div key={job.joborderId} style={jobCard}>
              <div
                onClick={() => navigate(`/job/${job.strID}`)}
                style={{ cursor: "pointer", flex: 1 }}
              >
                <h3 style={jobTitle}>{job.title}</h3>
                <p style={jobInfo}>{job.designation}</p>
                <p style={jobSkills}>
                  <strong>Skills:</strong> {job.skills || "Not specified"}
                </p>
                <p style={jobInfo}>
                  <strong>Location:</strong> {job.workplace || "Not specified"}
                </p>
                {/* <p style={jobId}>Job ID: {job.joborderId}</p> */}
              </div>

              <div style={buttonGroup}>
               <button
  style={shareBtn}
  onClick={() =>
    setDropdownVisibleId(dropdownVisibleId === job.joborderId ? null : job.joborderId)
  }
>
  {/* <FaFacebookF style={{ marginRight: "6px" }} /> */}
  SHARE
</button>

{dropdownVisibleId === job.joborderId && (
  <ul
    className="dropdown-menu dropdown-menu-right drop-down-pos"
    role="menu"
    style={{
      display: "block",
      position: "absolute",
      top: "100%",
      left: 0,
      backgroundColor: "#f5f0f0ff",
      zIndex: 9999,
      padding: "10px",
      borderRadius: "4px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    }}
  >
    <li>
      <a
        href={`https://www.facebook.com/share.php?u=https://atsdemo.e4softwares.com/career/careerDetails1/${job.strID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", gap: "6px", color: "#1877F2" }}
      >
        <FaFacebookF /> Facebook
      </a>
    </li>
    <li>
      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=https://atsdemo.e4softwares.com/career/careerDetails1/${job.strID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", gap: "6px", color: "#0A66C2" }}
      >
        <FaLinkedinIn /> LinkedIn
      </a>
    </li>
    <li>
      <a
        href={`https://wa.me/?text=https://atsdemo.e4softwares.com/career/careerDetails1/${job.strID}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", gap: "6px", color: "#25D366" }}
      >
        <FaWhatsapp /> WhatsApp
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com/e4software_services/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", gap: "6px", color: "#E4405F" }}
      >
        <FaInstagram /> Instagram
      </a>
    </li>
  </ul>
)}

                <button
                  style={applyBtn}
                  onClick={() => setApplyJob(job)}
                >
                  Apply
                </button>
              </div>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", marginTop: "30px" }}>
            No matching jobs found.
          </p>
        )}
      </div>

      {applyJob && (
  <div style={modalOverlay} onClick={closeModal}>
    <div style={modalContent} onClick={(e) => e.stopPropagation()}>
      {/* <h3 style={{ marginBottom: "20px" }}>Apply for: {applyJob.title}</h3> */}

      {/* ===== Resume Upload ===== */}
      <div style={formGroup}>
        <label style={labelStyle} htmlFor="resume">
          Upload Resume (PDF only)
        </label>
        <input
          style={inputStyle}
          id="resume"
          name="resume"
          type="file"
          accept="application/pdf"
          onChange={handleChange}
        />
        {errors.resume && <span style={errorText}>{errors.resume}</span>}
        {uploadedFileName && (
          <p style={{ marginTop: "8px", fontSize: "14px" }}>
            ✅ Uploaded: {uploadedFileName}
          </p>
        )}
        <button
          style={{ ...btnSubmit, marginTop: "10px" }}
          onClick={(e) => {
            e.preventDefault();
            handleUpload();
          }}
          disabled={uploading}
        >
          {uploading ? "Uploading..." : "Upload Resume"}
        </button>
      </div>

      {/* ===== Candidate Form (after upload) ===== */}
      {uploadedFileName && (
        <>
          <hr style={{ margin: "30px 0 20px" }} />
          <h4 style={{ marginBottom: "15px" }}>Candidate Information</h4>

          <div className="row" style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
            {[
              { label: "First Name *", name: "firstName" },
              { label: "Last Name *", name: "lastName" },
              { label: "Email *", name: "email" },
              { label: "Phone *", name: "phone" },
              { label: "Location *", name: "location" },
              { label: "Skill *", name: "skill" },
              { label: "Experience (Years) *", name: "experience" },
              { label: "Current CTC *", name: "ctc" },
              { label: "Expected CTC *", name: "expected" },
              { label: "Notice Period *", name: "notice" },
            ].map((field) => (
              <div
                key={field.name}
                style={{
                  flex: "1 1 45%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label style={labelStyle} htmlFor={field.name}>
                  {field.label}
                </label>
                <input
                  style={inputStyle}
                  id={field.name}
                  name={field.name}
                  type="text"
                  value={formData[field.name]}
                  onChange={handleChange}
                />
                {errors[field.name] && (
                  <span style={errorText}>{errors[field.name]}</span>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {/* ===== Buttons ===== */}
      <div style={btnGroupModal}>
        {/* <button style={btnCancel} onClick={closeModal} disabled={submitting}>
          Cancel
        </button> */}
        {uploadedFileName && (
          <button
            style={btnSubmit}
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            disabled={submitting}
          >
            {submitting ? "Submitting..." : "Submit Application"}
          </button>
        )}
      </div>
    </div>
  </div>
)}

    </div>
  );
}
